// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Glassmorphism effect: frosted glass appearance with blur and transparency */

.glass-panel {
  background: rgba(255, 255, 255, 0.05);
  /* eslint-disable-next-line css/use-baseline */
  backdrop-filter: blur(12px) saturate(180%);
  -webkit-backdrop-filter: blur(12px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.3);
  transition:
    background 0.3s ease,
    border-color 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/styles/utilities/glass-panel.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,0CAA0C;EAC1C,kDAAkD;EAClD,0CAA0C;EAC1C,2CAA2C;EAC3C;;0BAEwB;AAC1B","sourcesContent":["/* Glassmorphism effect: frosted glass appearance with blur and transparency */\n\n.glass-panel {\n  background: rgba(255, 255, 255, 0.05);\n  /* eslint-disable-next-line css/use-baseline */\n  backdrop-filter: blur(12px) saturate(180%);\n  -webkit-backdrop-filter: blur(12px) saturate(180%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.3);\n  transition:\n    background 0.3s ease,\n    border-color 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
